import { AadhaarVerification as DefaultAadhaarVerification } from "src/components/feature/Onboarding";

const AadhaarVerification = () => {
  return <DefaultAadhaarVerification />;
};

export default AadhaarVerification;
